
import profile from '../../apis/profile.js'
import Cookies from 'js-cookie'
import axios from '@/axios'
import Router from 'vue-router'
import state from "@/store/state";
export default {
  state: {
    current_user_data: null,
    current_user_permission: [],
    is_enabled_2fa: false
  },
  mutations: {
    CLEAR_CURRENT_USER: (state) => {
      state.current_user_data = undefined
      state.current_user_permission = undefined
      state.is_enabled_2fa = false
    },
    SET_CURRENT_USER_PERMISSION : (state, value) => {
      state.current_user_permission = value
    },

    SET_CURRENT_USER : (state, value) => {
      state.current_user_data = value.user
      Cookies.set('current_user_token', value.token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${value.token}`
    },

    SET_2FA_ENABLED_DISABLED : (state, value) => {
      state.is_enabled_2fa = value
    },

    UPDATE_PROFILE_AVATAR : (state, value) => {
      state.current_user_data.avatar = value
    },
  },
  getters: {
    isLogedIn: state => state.current_user_data !== null,
    currentUser: state => state.current_user_data,
    permissions: state => state.current_user_permission,
    is_enabled_2fa: state => state.is_enabled_2fa,
    current_user_reports: state => state.current_user_data.report,
    currentUserId: state => state.current_user_data.id,
  },
  actions: {
    setCurrentUser : ({commit}, payload) => { commit('SET_CURRENT_USER', payload) },

    async afterLogin ({commit}, fromLogin) {
      setInterval(() => {
        const cache_user_token = Cookies.get('current_user_token')
        if (!cache_user_token && window.location.pathname !== '/' ) {
          clearInterval(this)
          this.$router.push('/')
        }
        this.$router.push('/')
      }, 1000)
    },
    async autoLogin ({commit}) {
      try {
        const cache_user_token = Cookies.get('current_user_token')

        if (!this.getters.isLogedIn && cache_user_token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${cache_user_token}`
          const cache_user_data = (await profile.getCurrentUser()).data
          // const permissions = await profile.getPermissions()
          // commit('SET_CURRENT_USER_PERMISSION',  permissions.data.data.map(x => x.name))
          commit('SET_CURRENT_USER', {
            user: cache_user_data.data,
            token: cache_user_token,
          })
        }
      } catch (e) {
        await this.dispatch('logout')
      }
    },

    async login ({commit}, payload) {
      const login_data = (await profile.login(payload)).data.data
      if(!login_data.user.is_google_2fa_enable) {
        commit('SET_CURRENT_USER', login_data)

        // const permissions = await profile.getPermissions()
        // commit('SET_CURRENT_USER_PERMISSION',  permissions.data.data.map(x => x.name))
      } else {
        commit('SET_2FA_ENABLED_DISABLED',  login_data.user.is_google_2fa_enable)
      }
      return login_data
    },

    async loginAfter2FA({commit}, login_data) {
      commit('SET_CURRENT_USER', login_data)

      // const permissions = await profile.getPermissions()
      // commit('SET_CURRENT_USER_PERMISSION',  permissions.data.data.map(x => x.name))
    },

    async logout ({commit}) {
      try {
        await profile.logout()
        Cookies.remove('current_user_token')
        commit('CLEAR_CURRENT_USER')
        window.location = '/pages/login'
      } catch (e) {
        Cookies.remove('current_user_token')
        commit('CLEAR_CURRENT_USER')
        window.location = '/pages/login'
      }
    },

    async updateProfileAvatar({commit}, avatar) {
      commit('UPDATE_PROFILE_AVATAR', avatar)
    }

  }
}
